<template>
  <div class="scene-hotspot">
    <Steps
      v-if="step1"
      :title="$t('edit.hpInfo.hpIcon')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(-1)"
      @onClickNext="onClickNextTo(2)"
    >
      <template slot="body">
        <HListWithBtn :displayStyle="2">
          <template slot="body">
            <Icons @onSelectIcon="onSelectIcon" :currentIcon="sceneObj.icon_url" :type="2"></Icons>
          </template>
        </HListWithBtn>
      </template>
    </Steps>

    <Steps
      v-if="step2"
      :title="$t('edit.editMessage.selectScene')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(1)"
      @onClickNext="onClickNextTo(3)"
    >
      <template slot="body">
        <div class="scroll-base">
          <div class="item-wrapper">
            <ImageItem
                    :itemObj="value"
                    v-for="(value, k) in sceneList"
                    :key="k"
                    :selected="selectedScene"
                    @click.native="selectScene(value)"
            ></ImageItem>
          </div>
        </div>
      </template>
    </Steps>

    <Steps
      v-if="step3"
      :title="$t('edit.hpInfo.hpTitle')"
      :isShowArrow="true"
      :isLast="true"
      displayType
      @clickBack="onClickPreTo(2)"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <!-- <HListWithBtn rightButtonTile="選擇場景" @selectChange="onSelectChange">
          <template slot="body">
            <div class="imge-item" v-for="(item, index) in sceneObj.content" :key="index">
              <img :src="item.url" />
            </div>
          </template>
        </HListWithBtn>-->
        <!-- <div class="imge-item" v-for="(value, k) in sceneList" :key="k" @click="selectScene(value)">
          <img :src="item.url" />
        </div>-->
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="sceneObj.title" />
      </template>
    </Steps>
  </div>
</template>

<script>
import Icons from "../../hotspot/component/Icons.vue";
import Steps from "../../Steps.vue";
import HListWithBtn from "../../HListWithBtn.vue";
import { v4 as uuidv4 } from "uuid";
import { mapGetters } from "vuex";
import ImageItem from "../../ImageItem.vue";

export default {
  components: { Icons, Steps, HListWithBtn, ImageItem },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      step1: true,
      step2: false,
      step3: false,
      sceneObj: {
        type: "scene",
        hotspot_id: "hotspot_" + uuidv4(),
        icon_url: "",
        thumb_path:'',
        is_dynamic: 1,
        ath: "",
        atv: "",
        hath: "0",
        vatv: "0",
        title: "",
        is_show_title: 1,
        content: "",
        titleFontSize:14,
        tit_position_align:"top",
        tit_position_edge:"bottom",
        tit_position_x:0,
        tit_position_y:0,
        icon_scale:50,
      },
      selectedScene: [],
      sceneList: [],
    };
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId"]),
    newPicObj() {
      return this.$deepClone(this.sceneObj);
    },
  },
  mounted() {
    this.$bus.$on("updateHotspot", (e) => {
      if (e.hotspot_id == this.sceneObj.hotspot_id) {
        this.sceneObj.ath = e.ath;
        this.sceneObj.atv = e.atv;
      }
    });
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.selectedScene[0] = this.vrbase.scenes[value.content];
          this.sceneObj = value;
        }
      },
      immediate: true,
      deep: true,
    },
    newPicObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.sceneObj.ath = vh.hlookat;
          this.sceneObj.atv = vh.vlookat;
        }
        this.sceneObj.is_show_title = this.sceneObj.title == "" ? 0 : 1;
        this.$emit("change", this.sceneObj, oldVal);
      },
      deep: true,
    },
  },
  created() {
    this.sceneList = this.vrbase.scenes;
    console.log(this.sceneList);
  },
  methods: {
    onSelectIcon(item) {
      this.sceneObj.icon_url = item.icon_url;
      this.sceneObj.is_dynamic = item.is_dynamic;
      this.sceneObj.thumb_path = item.thumb_path;
    },
    onClickFinish() {
      if(!this.sceneObj.title) {
        this.$message.error(this.$t('edit.hpInfo.inputTitle'));
        return;
      }
      this.$emit("saveDataToStore", {
        key: this.sceneObj.hotspot_id,
        data: this.sceneObj,
      });
    },
    onClickPreTo(value) {
      if (value === -1) {
        this.$emit("onClickBack");
      } else if (value === 1) {
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      } else if (value === 2) {
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      }
    },
    onClickNextTo(value) {
      if (value === 2) {
        if (!this.sceneObj.icon_url) {
          this.$message.error(this.$t('edit.hpInfo.hpIcon'));
          return;
        }
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      } else if (value === 3) {
        if (!this.sceneObj.content) {
          this.$message.error(this.$t('edit.editMessage.selectScene'));
          return;
        }
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
      }
    },
    onSelectChange(value) {
      const item = { name: value.name, url: value.url };
      this.sceneObj.content = [...this.sceneObj.content, item];
    },
    selectScene(item) {
      this.selectedScene = [item];
      this.sceneObj.content = item.scene_id;
      this.sceneObj.title = item.scene_title;
    },
  },
};
</script>

<style lang="less" scoped>
.scene-hotspot {
  .imge-item {
    width: 47px;
    height: 47px;
    margin-right: 5px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  // .scroll-base {
  //   width: 100%;
  //   overflow-x: auto;
  //   .item-wrapper {
  //     display: flex;
  //     align-items: center;
  //     justify-content: flex-start;
  //   }
  // }
}
</style>
